<form
  autocomplete="off"
  class="credential2 auction-form-individual"
  [formGroup]="individualBatchAuctionForm"
  (submit)="saveIndividualBatchAuction()"
>
  <div class="form-group">
    <label for="" class="credential2__label w-100">Title</label>
    <input
      type="text"
      name="title"
      formControlName="title"
      class="credential2__input form-control"
      placeholder="Enter Tile"
      [class.is-invalid]="
        individualSubmitted && IndividualBatchControl['title'].errors
      "
    />
    <div class="invalid-feedback">
      <p>Title can not be blank.</p>
    </div>
  </div>
  <div class="form-group p-1">
    <label for="" class="credential2__label w-100">Item</label>
    <div class="row">
      <div class="col-md-6">
        <ng-select
          [clearable]="false"
          placeholder="Individual"
          class="ng-select-container-main"
          formControlName="item1"
          [loading]="ngSelectLoading"
          [notFoundText]="notFoundText"
          (change)="getProductInfo($event, false)"
          (scrollToEnd)="fetchNextPage()"
          (search)="onSearchInput($event)"
          [class.is-invalid]="
            individualSubmitted &&
            !individualBatchAuctionForm.controls['item1'].value &&
            !individualBatchAuctionForm.controls['item2'].value
          "
        >
          <ng-option
            *ngFor="let item of allIndividualProductList"
            [value]="item['product_id']"
            >{{ item["name"] }}
          </ng-option>
        </ng-select>
        <div class="invalid-feedback">
          <p>Please select an option from Individual or Batch.</p>
        </div>
      </div>

      <div class="col-md-6">
        <ng-select
          [clearable]="false"
          placeholder="Batch"
          class="ng-select-container-main"
          formControlName="item2"
          (change)="getbatchInfoForIndividual($event, true, 'individual_batch')"
          [class.is-invalid]="
            individualSubmitted &&
            !individualBatchAuctionForm.controls['item1'].value &&
            !individualBatchAuctionForm.controls['item2'].value
          "
        >
          <ng-option
            *ngFor="let item of batches"
            [value]="item['product_group_id']"
            >{{ item["group_name"] | titlecase }}
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="row mx-n2">
        <div class="col-md-6 px-2">
          <div class="form-group">
            <label for="" class="credential2__label w-100"
              >Auction Starts</label
            >
            <input
              type="text"
              name="auction_start_date"
              formControlName="auction_start_date"
              placeholder="Date"
              class="credential2__input form-control"
              readonly
              bsDatepicker
              [bsConfig]="{
                showWeekNumbers: false,
                dateInputFormat: 'DD-MM-YYYY'
              }"
              [class.is-invalid]="
                individualSubmitted &&
                IndividualBatchControl['auction_start_date'].errors
              "
            />
            <div class="invalid-feedback">
              <p>Auction start date can not be blank.</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 px-2">
          <div class="form-group">
            <label
              for=""
              class="credential2__label w-100 d-none d-md-inline-block"
              >&nbsp;</label
            >
            <input
              type="text"
              name="auction_start_time"
              formControlName="auction_start_time"
              placeholder="Time"
              class="credential2__input form-control"
              readonly
              [ngxTimepicker]="auctionStartTime"
              [class.is-invalid]="
                individualSubmitted &&
                IndividualBatchControl['auction_start_time'].errors
              "
            />
            <div class="invalid-feedback">
              <p>Auction start time required.</p>
            </div>
            <ngx-material-timepicker
              #auctionStartTime
            ></ngx-material-timepicker>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="row mx-n2">
        <div class="col-md-6 px-2">
          <div class="form-group">
            <label for="" class="credential2__label w-100">Auction Ends</label>
            <input
              type="text"
              name="auction_end_date"
              formControlName="auction_end_date"
              placeholder="Date"
              class="credential2__input form-control"
              readonly
              bsDatepicker
              [bsConfig]="{
                showWeekNumbers: false,
                dateInputFormat: 'DD-MM-YYYY'
              }"
              [class.is-invalid]="
                individualSubmitted &&
                IndividualBatchControl['auction_end_date'].errors
              "
            />
            <div class="invalid-feedback">
              <p>Auction end date can not be blank.</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 px-2">
          <div class="form-group">
            <label
              for=""
              class="credential2__label w-100 d-none d-md-inline-block"
              >&nbsp;</label
            >
            <input
              type="text"
              name="auction_end_time"
              formControlName="auction_end_time"
              placeholder="Time"
              class="credential2__input form-control"
              readonly
              [ngxTimepicker]="auctionEndTime"
              [class.is-invalid]="
                individualSubmitted &&
                IndividualBatchControl['auction_end_time'].errors
              "
            />
            <div class="invalid-feedback">
              <p>Auction end time required.</p>
            </div>
            <ngx-material-timepicker #auctionEndTime></ngx-material-timepicker>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="row mx-n2">
        <div class="col-md-6 px-2">
          <div class="form-group">
            <label for="" class="credential2__label w-100"
              >Live Auction Starts</label
            >
            <input
              type="text"
              name="live_auction_start_date"
              formControlName="live_auction_start_date"
              placeholder="Date"
              class="credential2__input form-control"
              readonly
              bsDatepicker
              [bsConfig]="{
                showWeekNumbers: false,
                dateInputFormat: 'DD-MM-YYYY'
              }"
              [class.is-invalid]="
                individualSubmitted &&
                IndividualBatchControl['live_auction_start_date'].errors
              "
            />
            <div class="invalid-feedback">
              <p>Live auction start date required.</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 px-2">
          <div class="form-group">
            <label
              for=""
              class="credential2__label w-100 d-none d-md-inline-block"
              >&nbsp;</label
            >
            <input
              type="text"
              name="live_auction_start_time"
              formControlName="live_auction_start_time"
              placeholder="Time"
              class="credential2__input form-control"
              readonly
              [ngxTimepicker]="liveAuctionStartTime"
              [class.is-invalid]="
                individualSubmitted &&
                IndividualBatchControl['live_auction_start_time'].errors
              "
            />
            <div class="invalid-feedback">
              <p>Live auction start time required.</p>
            </div>
            <ngx-material-timepicker
              #liveAuctionStartTime
            ></ngx-material-timepicker>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="row mx-n2">
        <div class="col-md-6 px-2">
          <div class="form-group">
            <label for="" class="credential2__label w-100"
              >Live Auction Ends</label
            >
            <input
              type="text"
              name="live_auction_end_date"
              formControlName="live_auction_end_date"
              placeholder="Date"
              class="credential2__input form-control"
              readonly
              bsDatepicker
              [bsConfig]="{
                showWeekNumbers: false,
                dateInputFormat: 'DD-MM-YYYY'
              }"
              [class.is-invalid]="
                individualSubmitted &&
                IndividualBatchControl['live_auction_end_date'].errors
              "
            />
            <!-- [minDate]="individualBatchAuctionForm.get('live_auction_start_date').value" -->
            <div class="invalid-feedback">
              <p>Live auction end date required.</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 px-2">
          <div class="form-group">
            <label
              for=""
              class="credential2__label w-100 d-none d-md-inline-block"
            >
              &nbsp;
            </label>
            <input
              type="text"
              name="live_auction_end_time"
              formControlName="live_auction_end_time"
              placeholder="Time"
              class="credential2__input form-control"
              readonly
              [ngxTimepicker]="liveAuctionEndTime"
              [class.is-invalid]="
                individualSubmitted &&
                IndividualBatchControl['live_auction_end_time'].errors
              "
            />
            <div class="invalid-feedback">
              <p>Live auction end time required.</p>
            </div>
            <ngx-material-timepicker
              #liveAuctionEndTime
            ></ngx-material-timepicker>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label for="" class="credential2__label w-100">Description</label>
        <textarea
          name="description"
          formControlName="description"
          placeholder="Type Something"
          class="credential2__textarea form-control"
          [class.is-invalid]="
            individualSubmitted && IndividualBatchControl['description'].errors
          "
        ></textarea>
        <div class="invalid-feedback">
          <p>Description can not be blank.</p>
        </div>
      </div>
    </div>
    <div *ngIf="auctionExists">
      <p class="ml-3 text-danger">
        **Some vehicle of Batch are already in auction.
      </p>
    </div>

    <!-- Open Bulk Auction Fields Start -->

    <div class="col-sm-6 col-lg-3" *ngIf="!openBulkAuctionField">
      <div class="form-group">
        <label for="" class="credential2__label text-truncate w-100 mb-1"
          >Opening Price (SAR)</label
        >
        <input
          type="text"
          name="opening_price"
          formControlName="opening_price"
          [inputMask]="currencyInputMask"
          placeholder="0.00"
          class="credential2__input form-control"
          [class.is-invalid]="
            (individualSubmitted &&
              IndividualBatchControl['opening_price'].errors) ||
            invalidIndividualOpeningPrice
          "
          (keyup)="runValidator($event)"
        />
        <div class="invalid-feedback" *ngIf="!invalidIndividualOpeningPrice">
          <p>Please provide Opening price.</p>
        </div>
        <div class="invalid-feedback" *ngIf="invalidIndividualOpeningPrice">
          <p>Opening price should be greater than 0.</p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3" *ngIf="!openBulkAuctionField">
      <div class="form-group">
        <label for="" class="credential2__label text-truncate w-100 mb-1"
          >Lowest Price to Accept (SAR)</label
        >
        <input
          type="text"
          name="lowest_price_to_accept"
          formControlName="lowest_price_to_accept"
          [inputMask]="currencyInputMask"
          placeholder="0.00"
          class="credential2__input form-control"
          [class.is-invalid]="
            (individualSubmitted &&
              IndividualBatchControl['lowest_price_to_accept'].errors) ||
            invalidIndividualLowestPriceToAccept
          "
          (keyup)="runValidator($event)"
        />
        <div
          class="invalid-feedback"
          *ngIf="!invalidIndividualLowestPriceToAccept"
        >
          <p>Please provide Lowest price to accept.</p>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="invalidIndividualLowestPriceToAccept"
        >
          <p>
            Lowest price to Accept should be greater than or equal to Opening
            price.
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3" *ngIf="!openBulkAuctionField">
      <div class="form-group">
        <label for="" class="credential2__label text-truncate w-100 mb-1"
          >Incremental Value (SAR)</label
        >
        <input
          type="text"
          name="incremental_value"
          formControlName="incremental_value"
          [inputMask]="currencyInputMask"
          placeholder="0.00"
          class="credential2__input form-control"
          [class.is-invalid]="
            (individualSubmitted &&
              IndividualBatchControl['incremental_value'].errors) ||
            invalidIndividualIncrementalValue
          "
          (keyup)="runValidator($event)"
        />
        <div
          class="invalid-feedback"
          *ngIf="!invalidIndividualIncrementalValue"
        >
          <p>Please provide Incremental value</p>
        </div>
        <div class="invalid-feedback" *ngIf="invalidIndividualIncrementalValue">
          <p>Incremental Value should be grater than 0</p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3" *ngIf="!openBulkAuctionField">
      <div class="form-group">
        <label for="" class="credential2__label text-truncate w-100 mb-1"
          >Buy Now Price (SAR)</label
        >
        <input
          type="text"
          name="buy_now_price"
          formControlName="buy_now_price"
          [inputMask]="currencyInputMask"
          placeholder="0.00"
          class="credential2__input form-control"
          [class.is-invalid]="
            (individualSubmitted &&
              IndividualBatchControl['buy_now_price'].errors) ||
            invalidIndividualBuyNowPrice2 ||
            invalidIndividualBuyNowPrice3
          "
          (keyup)="runValidator($event)"
        />
        <div
          class="invalid-feedback"
          *ngIf="
            !invalidIndividualBuyNowPrice2 && !invalidIndividualBuyNowPrice3
          "
        >
          <p>Please provide Buy now price</p>
        </div>
        <div class="invalid-feedback" *ngIf="invalidIndividualBuyNowPrice3">
          <p>
            Buy now price should be equal or greater than Lowest price to Accept
          </p>
        </div>
      </div>
    </div>

    <!-- END -->

    <div class="col-12 mt-4">
      <div class="auction-create__formArrayheader mb-3">
        <h4 class="heading-tertiary mr-3">Add New Field</h4>

        <div class="auction-create__formArrayBtnGrp ml-auto">
          <button
            type="button"
            class="btn btn__util2 gray-d w-100"
            (click)="addFields()"
          >
            Add
          </button>
        </div>
      </div>

      <div class="auction-create__formArray" formArrayName="fields">
        <div
          class="auction-create__formGroup"
          [formGroup]="field"
          *ngFor="let field of individualBatchFormArray.controls; index as i"
        >
          <div class="row mx-n2">
            <div [ngClass]="i >= 0 ? 'col-sm-5 px-2' : 'col-sm-6 px-2'">
              <div class="form-group mb-sm-0">
                <input
                  type="text"
                  name="entity_name"
                  formControlName="entity_name"
                  placeholder="Field Title"
                  class="credential2__input form-control"
                />
              </div>
            </div>
            <div [ngClass]="i >= 0 ? 'col-sm-5 px-2' : 'col-sm-6 px-2'">
              <div class="form-group" [ngClass]="i >= 0 ? 'mb-sm-0' : 'm-0'">
                <input
                  type="text"
                  name="entity_value"
                  formControlName="entity_value"
                  placeholder="Field Text"
                  class="credential2__input form-control"
                />
              </div>
            </div>

            <div class="col-sm-2 px-2" *ngIf="i >= 0">
              <button
                type="button"
                class="btn btn__main2 curved bg-red w-100"
                (click)="removeFields(i)"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-2 col-md-2 px-2" *ngFor="let images of getProductImages">
      <div *ngIf="!openBulkAuctionField">
        <div class="form-group position-relative auction-create__auctionImages">
          <img
            [src]="images"
            alt=""
            class="cursor-pointer"
            (click)="openViewer(images)"
          />
        </div>
      </div>
    </div>
    <ng-container *ngIf="getBatchImagesForIndividual.length">
      <div
        class="addBulkAuctionInIndividual px-4"
        [formGroup]="individualBulkAuctionForm"
        *ngIf="openBulkAuctionField"
      >
        <div formArrayName="auctionDetails">
          <div
            class="auctionDetails__main"
            *ngFor="
              let auctionDetail of individualBukFormArray.controls;
              index as i
            "
            [formGroup]="$any(auctionDetail)"
          >
            <input
              type="text"
              [ngModel]="getBatchImagesForIndividual?.[i].product_id"
              formControlName="itemId"
              hidden
            />

            <div class="row">
              <div class="col-12">
                <h3 class="auctionDetails__productTitle"></h3>
              </div>

              <div class="col-sm-6 col-lg-3">
                <div class="form-group">
                  <label
                    for=""
                    class="credential2__label text-truncate w-100 mb-1"
                    >Opening Price (SAR)</label
                  >
                  <input
                    type="text"
                    name="opening_price"
                    formControlName="openingPrice"
                    [inputMask]="currencyInputMask"
                    placeholder="0.00"
                    class="credential2__input form-control"
                  />
                </div>
              </div>
              <div class="col-sm-6 col-lg-3">
                <div class="form-group">
                  <label
                    for=""
                    class="credential2__label text-truncate w-100 mb-1"
                    >Lowest Price to Accept (SAR)</label
                  >
                  <input
                    type="text"
                    name="lowest_price_to_accept"
                    formControlName="lowestPriceToAccept"
                    [inputMask]="currencyInputMask"
                    placeholder="0.00"
                    class="credential2__input form-control"
                  />
                </div>
              </div>
              <div class="col-sm-6 col-lg-3">
                <div class="form-group">
                  <label
                    for=""
                    class="credential2__label text-truncate w-100 mb-1"
                    >Incremental Value (SAR)</label
                  >
                  <input
                    type="text"
                    name="incremental_value"
                    formControlName="incrementalValue"
                    [inputMask]="currencyInputMask"
                    placeholder="0.00"
                    class="credential2__input form-control"
                  />
                </div>
              </div>
              <div class="col-sm-6 col-lg-3">
                <div class="form-group">
                  <label
                    for=""
                    class="credential2__label text-truncate w-100 mb-1"
                    >Buy Now Price (SAR)</label
                  >
                  <input
                    type="text"
                    name="buy_now_price"
                    formControlName="buyNowPrice"
                    [inputMask]="currencyInputMask"
                    placeholder="0.00"
                    class="credential2__input form-control"
                  />
                </div>
              </div>

              <div
                class="col-sm-4 col-md-4 px-2"
                *ngFor="let image of getBatchImagesForIndividual[i]?.imageUrl"
              >
                <div
                  class="
                    form-group
                    position-relative
                    auction-create__auctionImages
                  "
                >
                  <img
                    [src]="image['presigned_url']"
                    alt=""
                    (click)="openViewer(image['presigned_url'])"
                    class="cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="row border-1">
    <div class="col-lg-6 col-12">
      <!-- Here -->
      <div class="auction-create__btnGrp ml-auto mt-4" *ngIf="isActiveAuction">
        <button
          type="button"
          (click)="onEndAuction()"
          class="btn btn__main curved w-100 bg-danger"
          [ladda]="endAuctionLoading"
        >
          End Auction
        </button>
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <!-- Here -->
      <div class="auction-create__btnGrp ml-auto mt-4">
        <button
          [disabled]="(adminApprove && lockStatus) || auctionExists"
          type="submit"
          class="btn btn__main curved w-100"
          [ladda]="laddaLoading"
        >
          {{ auctionId && isActiveAuction ? "Update" : "Create" }}
        </button>
      </div>
    </div>
  </div>
</form>
